<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- MODAL -->
  <div
    class="modal fade"
    id="processo-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-if="modal"
    style="margin-top: 30px"
    @close="visible = false"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Cadastrar processo</h4>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h3 class="card-title" style="color: white">Cadastro de processo</h3>
                  </div>

                  <div class="card-body">
                    <div class="row">
                      <!-- LEILOEIRO RESPONSÁVEL -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="endereco_cidade">Leiloeiro responsável</label>

                          <select
                            class="custom-select rounded-0"
                            id="endereco_cidade"
                            v-model="formData.leiloeiro_id"
                            style="text-transform: uppercase"
                          >
                            <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                              {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                            </option>
                          </select>

                          <span style="color: red" v-for="error in v$.leiloeiro_id.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- NÚMERO PROCESSO -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_numero">Número do processo</label>
                          <input
                            class="form-control"
                            id="processo_numero"
                            v-model="formData.processo_numero"
                            @blur="upper('processo_numero')"
                            style="text-transform: uppercase"
                          />

                          <span style="color: red" v-for="error in v$.processo_numero.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- NÚMERO REFERÊNCIA -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_referencia">Número de referência</label>
                          <input
                            class="form-control"
                            id="processo_referencia"
                            v-model="formData.processo_referencia"
                            @blur="upper('processo_referencia')"
                            style="text-transform: uppercase"
                          />
                        </div>
                      </div>

                      <!-- EXEQUENTE -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_exequente">Exequente</label>
                          <input
                            class="form-control"
                            id="processo_exequente"
                            v-model="formData.processo_exequente"
                            @blur="upper('processo_exequente')"
                            style="text-transform: uppercase"
                          />

                          <span style="color: red" v-for="error in v$.processo_exequente.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- EXECUTADO -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_executado">Executado</label>
                          <input
                            class="form-control"
                            id="processo_executado"
                            v-model="formData.processo_executado"
                            @blur="upper('processo_executado')"
                            style="text-transform: uppercase"
                          />

                          <span style="color: red" v-for="error in v$.processo_executado.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- VARA -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_vara">Vara</label>
                          <input
                            class="form-control"
                            id="processo_vara"
                            v-model="formData.processo_vara"
                            @blur="upper('processo_vara')"
                            style="text-transform: uppercase"
                          />
                        </div>
                      </div>

                      <!-- CLASSE -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="processo_classe">Classe processual</label>
                          <input
                            class="form-control"
                            id="processo_classe"
                            v-model="formData.processo_classe"
                            @blur="upper('processo_classe')"
                            style="text-transform: uppercase"
                          />

                          <span style="color: red" v-for="error in v$.processo_classe.$errors" :key="error.$uid">
                            {{ error.$message }}
                          </span>
                        </div>
                      </div>

                      <!-- ENDERECO ESTADO -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="endereco_estado">Estado</label>

                          <select
                            class="custom-select rounded-0"
                            id="endereco_estado"
                            v-model="formData.estado"
                            @change="buscarCidades()"
                            style="text-transform: uppercase"
                            :disabled="disable_estado"
                          >
                            <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                              {{ estado.nome }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ENDERECO CIDADE -->
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="endereco_cidade">Cidade</label>

                          <select
                            :disabled="disable_cidade"
                            class="custom-select rounded-0"
                            id="endereco_cidade"
                            v-model="formData.cidade"
                            style="text-transform: uppercase"
                          >
                            <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">
                              {{ cidade.nome }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Cadastrar</button>

                    <button data-toggle="modal" id="cancelar_processo" data-target="#processo-modal" class="btn btn-danger">Voltar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- CADASTRO-->
  <div class="row" v-if="!modal">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de processos</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- LEILOEIRO RESPONSÁVEL -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco_cidade">Leiloeiro responsável</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.leiloeiro_id" style="text-transform: uppercase">
                  <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                    {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                  </option>
                </select>

                <span style="color: red" v-for="error in v$.leiloeiro_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO PROCESSO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_numero">Número do processo</label>
                <input
                  class="form-control"
                  id="processo_numero"
                  v-model="formData.processo_numero"
                  @blur="upper('processo_numero')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.processo_numero.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO REFERÊNCIA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_referencia">Número de referência</label>
                <input
                  class="form-control"
                  id="processo_referencia"
                  v-model="formData.processo_referencia"
                  @blur="upper('processo_referencia')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- EXEQUENTE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_exequente">Exequente</label>
                <input
                  class="form-control"
                  id="processo_exequente"
                  v-model="formData.processo_exequente"
                  @blur="upper('processo_exequente')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.processo_exequente.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXECUTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_executado">Executado</label>
                <input
                  class="form-control"
                  id="processo_executado"
                  v-model="formData.processo_executado"
                  @blur="upper('processo_executado')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.processo_executado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VARA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_vara">Vara</label>
                <input
                  class="form-control"
                  id="processo_vara"
                  v-model="formData.processo_vara"
                  @blur="upper('processo_vara')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- CLASSE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_classe">Classe processual</label>
                <input
                  class="form-control"
                  id="processo_classe"
                  v-model="formData.processo_classe"
                  @blur="upper('processo_classe')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.processo_classe.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_estado">Estado</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade" style="text-transform: uppercase">
                  <option value=""></option>
                  <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- DATA LEILOES 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_data_leiloes">Data dos leilões</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_data_leiloes"
                  placeholder="Data dos leilões"
                  v-model="formData.processo_data_leiloes"
                  rows="2"
                  cols="50"
                ></textarea>
              </div>
            </div>
           -->

            <!-- ONUS
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_onus">Ônus</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_onus"
                  placeholder="Ônus"
                  v-model="formData.processo_onus"
                  rows="2"
                  cols="50"
                  @blur="upper('processo_onus')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
 -->
            <!-- ADVOGADOS
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_advogados">Advogados</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_advogados"
                  placeholder="Advogados"
                  v-model="formData.processo_advogados"
                  rows="2"
                  cols="50"
                  @blur="upper('processo_advogados')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
 -->
            <!-- LOCAL 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_local_leilao">Local do leilão</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_local_leilao"
                  placeholder="Local do leilão"
                  v-model="formData.processo_local_leilao"
                  @blur="upper('processo_local_leilao')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
-->
            <!-- JUIZ COMPLEMENTO
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_juiz_complemento">Juiz complemento (Sr. Sra.)</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_juiz_complemento"
                  placeholder="Sr. Sra."
                  v-model="formData.processo_juiz_complemento"
                  @blur="upper('processo_juiz_complemento')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
 -->
            <!-- NOME DO JUIZ 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_juiz">Nome do Juiz</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_juiz"
                  placeholder=""
                  v-model="formData.processo_juiz"
                  @blur="upper('processo_juiz')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
-->
            <!-- DEPOSITÁRIO PÚBLICO
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_depositario">Depositário público</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_depositario"
                  placeholder="Depositário público"
                  v-model="formData.processo_depositario"
                  rows="1"
                  cols="50"
                  @blur="upper('processo_depositario')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
 -->
            <!-- AVALIAÇÃO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_avaliacao">Avaliação</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_avaliacao"
                  placeholder="0.00"
                  v-model="formData.processo_valor_avaliacao"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
-->
            <!-- ORIGINÁRIO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_originario">Valor originário</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_originario"
                  placeholder="0.00"
                  v-model="formData.processo_valor_originario"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
-->
            <!-- DÉBITO
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_debito">Valor do débito</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_debito"
                  placeholder="0.00"
                  v-model="formData.processo_valor_debito"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
          --></div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateFields()">Cadastrar</button>
          <a type="submit" href="/admin/processos" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "estado_selecionado", "cidade_selecionada", "cidades_buscadas", "leiloeiros", "modal", "action"],

  components: { Loading },

  data() {
    return {
      nome: "",
      isLoading: false,
      cidades: [],
      disable_estado: false,
      disable_cidade: false,
    };
  },

  setup() {
    const formData = reactive({
      leiloeiro_id: "",
      processo_numero: "",
      processo_referencia: "",
      processo_executado: "",
      processo_exequente: "",
      processo_comitente: "",
      processo_vara: "",
      processo_classe: "",
      processo_data_leiloes: "",
      processo_onus: "",
      processo_advogados: "",
      processo_local_leilao: "",
      processo_juiz_complemento: "",
      processo_juiz: "",
      processo_depositario: "",
      processo_valor_avaliacao: "",
      processo_valor_originario: "",
      processo_valor_debito: "",

      cidade: "",
      estado: "",
    });

    const rules = computed(() => {
      return {
        leiloeiro_id: { required },
        processo_numero: { required },
        processo_executado: { required },
        processo_exequente: { required },
        processo_classe: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    if (this.modal) {
      document.getElementById("cancelar_processo").click();
    }

    this.formData.leiloeiro_id = this.leiloeiros[0].id;

    this.cidades = this.cidades_buscadas;

    console.log("Estado");
    console.log(this.estado_selecionado);

    console.log("Cidade");
    console.log(this.cidade_selecionada);

    if (this.estado_selecionado) {
      this.formData.estado = this.estado_selecionado;
      this.disable_estado = true;
    }

    if (this.cidade_selecionada) {
      this.formData.cidade = this.cidade_selecionada;
      this.disable_cidade = true;
    }
  },

  methods: {
    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        leiloeiro_id: this.formData.leiloeiro_id,
        processo_numero: this.formData.processo_numero,
        processo_referencia: this.formData.processo_referencia,
        processo_executado: this.formData.processo_executado,
        processo_exequente: this.formData.processo_exequente,
        processo_comitente: this.formData.processo_comitente,
        processo_vara: this.formData.processo_vara,
        processo_classe: this.formData.processo_classe,
        processo_data_leiloes: this.formData.processo_data_leiloes,
        processo_onus: this.formData.processo_onus,
        processo_advogados: this.formData.processo_advogados,
        processo_local_leilao: this.formData.processo_local_leilao,
        processo_juiz_complemento: this.formData.processo_juiz_complemento,
        processo_juiz: this.formData.processo_juiz,
        processo_depositario: this.formData.processo_depositario,
        processo_valor_avaliacao: this.formData.processo_valor_avaliacao,
        processo_valor_originario: this.formData.processo_valor_originario,
        processo_valor_debito: this.formData.processo_valor_debito,
        cidade_id: this.formData.cidade,
        estado_id: this.formData.estado,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/processo/store`, data)
        .then((response) => {
          if (response.data.success) {
            if (this.modal) {
              this.showSuccessMessage("Processo cadastrado!");
              this.action(response.data.id);
              this.isLoading = false;

              //this.action(0);
              document.getElementById("cancelar_processo").click();
            } else {
              this.isLoading = false;

              this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Processo cadastrado", "/admin/processos");
            }
          } else {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops....", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          this.formData.cidade = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 900px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 700px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
